module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAAFiUAABYlAUlSJPAAAACUSURBVDhPY/hPIgBpKN9R7jTHyWO+By7kNs/Nb5Hfqy+voBpCl4UKNwtLt0vjQhJtEopdis8/PYdqiFoZJdkmqdSthAvJd8qr96m/+PxiVAOaImREfw2RKyIlWiUUuhRwIdkOWbVetRefYBrCloURTBpAe559egbVcOfNnfNPz198dhEXuvDsApD89fcXVAMJ4P9/AB/AjQKRgWMbAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./ClientApp/images/node-icons/storage-node.png
// module id = 1000
// module chunks = 0